class SearchForm extends HTMLElement {
  // Quote each word to keep matching literal while allowing different word order.
  static buildQuery(value) {
    const text = value.trim();
    if (!text || /\b[a-z_][\w.]*:/i.test(text)) return text;
    const terms = text.match(/"(?:\\.|[^"\\])*"|[^\s"]+/g) || [];
    return terms.map((term) => {
      if (term.startsWith('"') && term.endsWith('"')) return term;
      return '"' + term.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
    }).join(' AND ');
  }

  static displayQuery(value) {
    // Only decode the format generated above; leave advanced searches intact.
    if (!/^"(?:\\.|[^"\\])*"(?: AND "(?:\\.|[^"\\])*")*$/.test(value)) return value;
    return (value.match(/"(?:\\.|[^"\\])*"/g) || []).map((term) =>
      term.slice(1, -1).replace(/\\([\\"])/g, '$1')
    ).join(' ');
  }

  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.value = SearchForm.displayQuery(this.input.value);
      this.input.form.addEventListener('formdata', (event) => {
        const query = event.formData.get('q');
        if (typeof query === 'string') event.formData.set('q', SearchForm.buildQuery(query));
      });
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
    }
  }

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
